import { addMonths, addYears, differenceInDays, differenceInMonths, differenceInYears, isValid, parseISO, getDaysInMonth } from 'date-fns'

/**
 * Farmer-friendly livestock age from DOB → now:
 *  - <7d:        "1d"
 *  - <8w (56d):  "3w 2d"
 *  - <24m:       "6m 23d"
 *  - >=24m:      "2y 4m"
 *
 * Uses calendar months/years (date-fns), not fixed 30-day months.
 */
export function formatLivestockAge(dobInput, opts = {}) {
    const {
        now = new Date(),
        weeksCutoverDays = 182, // switch from w/d → m/d at ~8 weeks
        yearsCutoverMonths = 24, // switch from m/d → y/m at 2 years
    } = opts

    const dob = dobInput instanceof Date ? dobInput : typeof dobInput === 'string' ? parseISO(dobInput) : new Date(dobInput)

    if (!isValid(dob) || !isValid(now)) return ''
    if (dob > now) return '0d'

    const totalDays = differenceInDays(now, dob)
    if (totalDays < weeksCutoverDays) return `${totalDays}d`

    const totalMonths = differenceInMonths(now, dob)
    if (totalMonths < yearsCutoverMonths) {
        const anchor = addMonths(dob, totalMonths)
        const days = differenceInDays(now, anchor)
        const daysAsDecimal = totalMonths + parseFloat((days / getDaysInMonth(anchor)).toFixed(1))

        return days ? `${daysAsDecimal}m` : `${totalMonths}m`
    }

    const years = differenceInYears(now, dob)
    const afterYears = addYears(dob, years)
    const months = differenceInMonths(now, afterYears)
    const monthsAsDecimal = years + parseFloat((months / 12).toFixed(1))
    return months ? `${monthsAsDecimal}y` : `${years}y`
}
